import AxiosService from './AxiosService';

export const get = config => AxiosService.get(`am_recovery_questions`, config);
